import React, {useEffect} from 'react';
import SVG from "react-inlinesvg";
import {Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import {NavLink} from 'react-router-dom';
import {toAbsoluteUrl} from "../../../../../../../_metronic/_helpers";
import {errorMessage, formatAmount} from '../../../../../../util/Helpers';
import ErrorMessage from './ErrorMessage';
import cogoToast from "cogo-toast";
import {useGetOrderQuery} from "../../../../../../../redux/apiSlice";


const CreateOrder = ({show, action: {action, error, data}, onHide}) => {
    return <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
    >
        <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                    />
                </span> {action}
            </Modal.Title>
            <button type="button" className="close" onClick={onHide}>
                <span aria-hidden="true" className="d-block">×</span>
                <span className="sr-only">Close</span>
            </button>
        </Modal.Header>
        <Modal.Body>
            <ErrorMessage {...{error}} />
            <div className="px-md-5">
                <div className="row">
                    <div className="col-md-4 h6">
                        User
                    </div>
                    <div className="col-md h6 text-muted">
                        <NavLink to={`/users/view/${data?.userId}`} target="_blank">
                            {`${data.meta?.firstName ?? ""} ${data.meta?.lastName ?? ""}`}
                        </NavLink>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Email
                    </div>
                    <div className="col-md h6 text-muted">
                        {data.meta?.email}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Account Id
                    </div>
                    <div className="col-md h6 text-muted">
                        <NavLink to={`/users/view/${data?.userId}/account-information/${data?.accountId}`}
                                 className="text-muted text-hover-primary" target="_blank">
                            {data?.accountId}
                        </NavLink>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Provider
                    </div>
                    <div className="col-md h6 text-muted">
                        {data.meta?.provider?.toUpperCase()}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Instrument
                    </div>
                    <div className="col-md h6 text-muted">
                        ({data.meta?.symbol}) {data.meta?.name}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Exchange
                    </div>
                    <div className="col-md h6 text-muted">
                        {data.meta?.exchange}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Side
                    </div>
                    <div className="col-md h6 text-muted">
                        {data?.side}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Type
                    </div>
                    <div className="col-md h6 text-muted">
                        {data?.type}
                    </div>
                </div>
                <div className={`row mt-4 ${data.amount ? "" : "d-none"}`}>
                    <div className="col-md-4 h6">
                        Amount
                        <OverlayTrigger
                            overlay={
                                <Tooltip>Estimated Amount</Tooltip>
                            }
                        >
                            <button
                                className={`btn svg-icon svg-icon-sm svg-icon-info ml-3 p-0 pb-1 ${!data.priority || (data.type === "MARKET" && data.priority === "amount") ? "d-none" : ""}`}>
                                <SVG
                                    title=" "
                                    src={toAbsoluteUrl("/media/svg/icons/Code/Question-circle.svg")}
                                />
                            </button>
                        </OverlayTrigger>
                    </div>
                    <div className="col-md h6 text-muted">
                        {formatAmount(data.meta?.currency, data?.amount)}
                    </div>
                </div>
                <div className={`row mt-4 ${data?.price ? "" : "d-none"}`}>
                    <div className="col-md-4 h6">
                        Price
                    </div>
                    <div className="col-md h6 text-muted">
                        {formatAmount(data.meta?.currency, data?.price)}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Quantity
                        <OverlayTrigger
                            overlay={
                                <Tooltip>Estimated Quantity</Tooltip>
                            }
                        >
                            <button
                                className={`btn svg-icon svg-icon-sm svg-icon-info ml-3 p-0 pb-1 ${!data.priority || (data.type === "MARKET" && data.priority === "quantity") ? "d-none" : ""}`}>
                                <SVG
                                    title=" "
                                    src={toAbsoluteUrl("/media/svg/icons/Code/Question-circle.svg")}
                                />
                            </button>
                        </OverlayTrigger>
                    </div>
                    <div className="col-md h6 text-muted">
                        {data?.quantity?.toLocaleString(undefined, {maximumFractionDigits: 10})}
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
            <button
                type="button"
                onClick={onHide}
                className="btn btn-primary btn-elevate px-5"
            >
                Okay
            </button>
        </Modal.Footer>
    </Modal>
}

export default CreateOrder;